import { RouteObject } from 'react-router';

import { DefaultErrorElement } from 'src/app/DefaultErrorElement';
import { NotFoundChildRoute } from 'src/app/NotFoundChildRoute';
import { BAMBI_API_BASE_URL } from 'src/common/external/bambi-api/constants';
import { tripSubscriptionsRoutes } from 'src/features/trip/trip-subscriptions/routes';
import { TripSubscriptionsLayout } from 'src/features/trip/trip-subscriptions/TripSubscriptionsLayout';

import { TripManagementRoute } from './management/TripManagementRoute';
import { RomAllRequestsLayout } from './rom/all-requests/RomAllRequestsLayout';
import { romAllRequestsRoutes } from './rom/routes';
import { RouteTemplateRoute } from './routeTemplates/RouteTemplateRoute';
import { TripSummaryRoute } from './summary/TripSummaryRoute';

export type TripSummaryRouteParams = {
  tripId: string;
};

export const tripRoutes: RouteObject[] = [
  {
    index: true,
    element: <TripManagementRoute />,
  },
  {
    path: 'test-request-form',
    element: <TripRequestFormTestRoute />,
  },
  {
    path: ':tripId/summary',
    element: <TripSummaryRoute />,
  },
  {
    path: 'subscriptions/*',
    element: <TripSubscriptionsLayout />,
    children: tripSubscriptionsRoutes,
    errorElement: <DefaultErrorElement />,
  },
  {
    path: 'requests/*',
    element: <RomAllRequestsLayout />,
    children: romAllRequestsRoutes,
    errorElement: <DefaultErrorElement />,
  },
  {
    path: 'route-templates/*',
    element: <RouteTemplateRoute />,
    errorElement: <DefaultErrorElement />,
  },
  {
    path: '*',
    element: (
      <NotFoundChildRoute routePath="/trips" linkText="Go back to trips" />
    ),
  },
];

export const rideOrderingPortalTripRoutes: RouteObject[] = [
  {
    index: true,
    element: <TripManagementRoute />,
  },
  {
    path: ':tripId/summary',
    element: <TripSummaryRoute />,
  },
  {
    path: '*',
    element: <NotFoundChildRoute />,
  },
];

function TripRequestFormTestRoute() {
  return (
    <iframe
      title="Trip Request Form"
      src={`${BAMBI_API_BASE_URL}public/trips/embed/trip-request/?access_token=test123`}
      // Overlay entire screen or they can give it a relatively positioned parent
      style={{
        position: 'absolute',
        // 4rem is the height of our header
        top: '4rem',
        left: 0,
        bottom: 0,
        right: 0,
        width: '100%',
        height: '100%',
        zIndex: 1000,
      }}
    />
  );
}
